import React, {Component} from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from './../actions'
import SearchContainer from './../containers/site/search_container'

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
})

class SiteSearch extends Component {

  // 初期化時のトリガをここで行う
  componentWillMount() {
    this.props.actions.getSystemLabelMasters()
  }

  render() {
    return (
      <BrowserRouter>
        <Routes>
          <Route exact path={'/site/items'} element={<SearchContainer />} />
          <Route exact path={'/site/items/BodyKeijou-:body_type'} element={<SearchContainer />} />
          <Route exact path={'/site/items/Maker-:maker'} element={<SearchContainer />} />
          <Route exact path={'/site/items/BrandKey-:brand'} element={<SearchContainer />} />
          <Route exact path={'/site/items/StorageLocation-:storage_location'} element={<SearchContainer />} />
          <Route exact path={'/site/items/BodySIze-:body_size'} element={<SearchContainer />} />
          <Route exact path={'/site/items/fw-:freeword'} element={<SearchContainer />} />
        </Routes>
      </BrowserRouter>
    )
  }
}

export default connect(null, mapDispatchToProps)(SiteSearch)
